// ═══════════════════════════════════════════════════════════════════════════════
// Helper — floating bottom confirm bar (single primary action above bottom nav)
// ═══════════════════════════════════════════════════════════════════════════════

import { FIXED_ABOVE_BOTTOM_NAV } from '../../lib/layoutChrome';
import { portalToBody } from '../../lib/portalToBody';
import { AppButton } from '../ui/AppButton';

type HelperFloatingConfirmBarProps = {
  onConfirm: () => void;
  disabled?: boolean;
  label: string;
  loadingLabel: string;
  isLoading?: boolean;
  ariaLabel: string;
};

export const HelperFloatingConfirmBar = ({
  onConfirm,
  disabled = false,
  label,
  loadingLabel,
  isLoading = false,
  ariaLabel,
}: HelperFloatingConfirmBarProps) => {
  return portalToBody(
    <div
      className={`${FIXED_ABOVE_BOTTOM_NAV} border-t border-gray-200 bg-white p-4 shadow-lg dark:border-gray-700 dark:bg-gray-900`}
      role="region"
      aria-label={ariaLabel}
    >
      <div className="mx-auto max-w-lg">
        <AppButton
          variant="primary"
          size="lg"
          fullWidth
          onClick={onConfirm}
          disabled={disabled}
          aria-label={ariaLabel}
          className="shadow-md"
        >
          {isLoading ? loadingLabel : label}
        </AppButton>
      </div>
    </div>,
  );
};
